import { createSelector } from 'reselect';
import * as ConsentsSelectors from './consents/selectors';

export const getAllDictionariesLoaded = createSelector(
	[ConsentsSelectors.getLoaded],
	(consentsLoaded) => {
		return consentsLoaded;
	}
);
